import { Link, graphql, navigate, useStaticQuery } from "gatsby";
import { gsap } from "gsap";
import parse from "html-react-parser";
import React, { useCallback, useEffect, useRef, useState } from "react";
import ImageOpt from "../components/ImageOpt";

const Thankyou = (props) => {
  useEffect(() => {
    document.body.classList.remove("menu-open");
  }, []);
  const menuElement = useRef();
  const [menuOpenStatus, setMenuOpenStatus] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuOpenBooking, setMenuOpenBooking] = useState(false);

  useEffect(() => {
    menuElement.current = gsap.timeline({
      paused: true,
      onStart: () => {
        document.body.classList.add("menu-open");

        setMenuOpen(true);
      },
      onReverseComplete: () => {
        document.body.classList.remove("menu-open");

        setMenuOpen(false);
      },
    });
    menuElement.current.to(".main-nav", {
      duration: 0.6,
      clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
      left: 0,
      ease: "Power3.InOut",
    });
    menuElement.current.from(
      ".dark-logo",
      { stagger: 0.1, opacity: 0, y: 20, ease: "Power3.InOut" },
      "-=0"
    );
    menuElement.current.from(
      ".leftMenu",
      { stagger: 0.1, opacity: 0, y: 20, ease: "Power3.InOut" },
      "-=0"
    );
    menuElement.current.from(
      ".mainNav_Contact--info",
      { stagger: 0.1, opacity: 0, y: 20, ease: "Power3.InOut" },
      "-=0"
    );
    menuElement.current.from(
      ".mainNav__col--right",
      { stagger: 0.1, opacity: 0, y: 20, ease: "Power3.InOut" },
      "-=0"
    );
  }, []);
  useEffect(() => {
    menuOpenStatus ? menuElement.current.play() : menuElement.current.reverse();
  }, [menuOpenStatus]);

  /* Custom Cursor Js start */
  const handleScrollActiveClass = useCallback((event) => {
    if (document.getElementById("cursor")) {
      var element = document.querySelector("body");
      var position = element.getBoundingClientRect();
      if (position.top >= 0 && position.bottom <= window.innerHeight + 280) {
        document.getElementById("cursor").style.visibility = "visible";
      }
    }
  }, []);
  useEffect(() => {
    window.addEventListener("scroll", handleScrollActiveClass);
    return () => {
      window.removeEventListener("scroll", handleScrollActiveClass);
    };
  }, [handleScrollActiveClass]);

  useEffect(() => {
    var button = document.querySelector(".cursor");

    var disableDragButtonMove = (e) => {
      gsap.to(button, {
        css: {
          left: e.clientX,
          top: e.clientY,
        },
      });
    };
    window.addEventListener("pointermove", disableDragButtonMove);
    window.addEventListener("mousemove", disableDragButtonMove);

    document.querySelectorAll(".cursor-scale, a, button").forEach((el) => {
      el.addEventListener("mouseover", () => {
        gsap.to(button, {
          css: {
            transform: "translate(-50%, -50%) scale(2.5)",
            "mix-blend-mode": "difference",
          },
        });
      });
      el.addEventListener("mouseout", () => {
        gsap.to(button, {
          css: {
            transform: "translate(-50%, -50%) scale(1)",
            border: "1px solid #E59978",
            "mix-blend-mode": "normal",
            backgroundColor: "transparent",
          },
        });
      });
    });
  }, []);
  /* Custom Cursor Js end */

  const headerData = useStaticQuery(graphql`
    query {
      wp {
        fluxDnaSettings {
          fluxDna {
            enquiryImage {
              altText
              mediaItemUrl
            }
            enquiryLogo {
              altText
              mediaItemUrl
            }
            thankyouHeading
            thankyouDescription
            thankyouImage {
              altText
              mediaItemUrl
            }
            sidebarMenuEmail
            sidebarMenuPhone
            sidebarMenuSocial {
              icon {
                altText
                mediaItemUrl
              }
              link {
                target
                title
                url
              }
            }
            sidebarTopMenu: headerSidebarMenuTop {
              itemParent
              itemChild {
                child {
                  target
                  title
                  url
                }
              }
              item {
                target
                title
                url
              }
            }
            sidebarBottomMenu: headerSidebarMenuBottom {
              item {
                target
                title
                url
              }
            }
          }
        }
      }
    }
  `);

  const headerDataList = headerData.wp.fluxDnaSettings.fluxDna;
  const headersideTopMenu = headerDataList.sidebarTopMenu;
  const headersideBottomMenu = headerDataList.sidebarBottomMenu;

  return (
    <div className="fullPageanimation headerSecondary">
      <>
        <section className="thank-you text-center overflow-hidden">
          <div className="flex flex-wrap">
            <div className="lg:w-8/12 w-full closemenu">
              <div
                className="xl:px-80 lg:px-40
             px-20 lg:py-40 pb-20 pt-20 relative h-screen overflow-y-auto enquiry-left overflow-hidden"
              >
                <div className="enquiry-header relative z-99">
                  <div className="flex flex-wrap justify-between">
                    <div className="logo z-99">
                      {headerDataList?.enquiryLogo && (
                        <Link to="/">
                          <img
                            src={headerDataList.enquiryLogo.mediaItemUrl}
                            alt="Logo"
                            className="m-auto desktop-logo smscreen2:w-[120px]"
                            loading="lazy"
                            width={168}
                            height={74}
                          />
                        </Link>
                      )}
                    </div>
                    <div className="top-navbar flex flex-wrap items-center gap-x-4 mdscreen:pl-0">
                      {/* <Link to="/" className="font-heading text-15 font-400 text-white uppercase">Back to site</Link> */}
                      <button
                        onClick={() => navigate(-2)}
                        className="font-heading text-15 font-400 text-white uppercase"
                      >
                        Back to site{" "}
                      </button>

                      <div className="flex flex-wrap items-center">
                        <div
                          onClick={() => {
                            setMenuOpenStatus(!menuOpenStatus);
                          }}
                          onKeyDown={() => {
                            setMenuOpenStatus(!menuOpenStatus);
                          }}
                          aria-hidden="true"
                          className={`navbar-icon flex items-center cursor-pointer hamburger menu-open-test cursor-scale ${
                            menuOpen ? "active" : ""
                          }`}
                        >
                          <span className="uppercase font-heading text-white text-15 font-400 pr-15 hidden">
                            Close menu
                          </span>
                          <div className="menu-line space-y-2 w-50 smscreen2:w-auto menu-line cursor-pointer">
                            <svg
                              width="20"
                              height="2"
                              viewBox="0 0 20 2"
                              fill="none"
                            >
                              <path
                                d="M0 1H20"
                                stroke="white"
                                strokeWidth="1.5"
                              />
                            </svg>
                            <svg
                              width="20"
                              height="2"
                              viewBox="0 0 20 2"
                              fill="none"
                            >
                              <path
                                d="M0 1H20"
                                stroke="white"
                                strokeWidth="1.5"
                              />
                            </svg>
                            <svg
                              width="20"
                              height="2"
                              viewBox="0 0 20 2"
                              fill="none"
                            >
                              <path
                                d="M0 1H20"
                                stroke="white"
                                strokeWidth="1.5"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="scroll-form-main w-[580px] lgscreen:w-full mx-auto thankYou-content flex flex-col justify-center items-center gap-y-6 h-[calc(100%_-_100px)]">
                  {headerDataList?.thankyouHeading && (
                    <div className="top-info flex justify-center flex-wrap items-center w-[400px] lgscreen:w-full">
                      <h4 className="text-white lg:text-34">
                        {headerDataList.thankyouHeading}
                      </h4>
                    </div>
                  )}
                  {headerDataList?.thankyouDescription && (
                    <div className="content white">
                      {parse(headerDataList.thankyouDescription)}
                    </div>
                  )}
                  <Link to="/" className="btn btn-lightblue mt-20">
                    back to home
                  </Link>
                </div>
              </div>
              <div className="main-nav nav-container smscreen2:pb-30 !w-full">
                <div className="menu-overlay h-full fixed w-full top-0 left-0 bg-darkblue"></div>
                <div className="w-[33.33%] absolute right-0 lgscreen:hidden">
                  <ImageOpt
                    imgData={headerDataList.enquiryImage.mediaItemUrl}
                    imgClass="h-screen w-full object-cover"
                    imgAlt={headerDataList.enquiryImage.altText}
                    width={1440}
                    height={640}
                    imgLoad="lazy"
                  />
                </div>
                <div className="mainNav__wrap relative m-auto p-menu_mobile z-99 h-full overflow-y-auto img-grid-bx img-revel-anim">
                  <div className="pl-120 pr-90 h-full xlscreen:px-40">
                    <div className="mainNav__wrap--inner h-full">
                      <div className="md:w-8/12 lgscreen:ml-auto pr-80 xlscreen:pr-40 lgscreen:pr-0 pt-100 desktop2:pt-80 text-right w-full">
                        <div className="mainNav__col leftMenu">
                          <ul className="navMenu hover-underline-solid lg:pt-40 grid gap-y-2 text-white">
                            {headersideTopMenu.map((menu, i) => {
                              if (menu.itemParent === "no") {
                                return (
                                  <li key={i}>
                                    <Link
                                      to={menu.item.url}
                                      target={menu.item.target}
                                    >
                                      {menu.item.title}
                                    </Link>
                                  </li>
                                );
                              } else {
                                return (
                                  <li key={i}>
                                    <Link
                                      to={menu.item.url}
                                      target={menu.item.target}
                                    >
                                      {menu.item.title}
                                    </Link>
                                    <ul className="child-menu flex flex-wrap justify-end gap-x-6 smscreen:flex-col">
                                      {menu.itemChild &&
                                        menu.itemChild.map((child_menu, k) => {
                                          return (
                                            <li className="relative" key={k}>
                                              <Link
                                                to={child_menu.child.url}
                                                target={child_menu.child.target}
                                              >
                                                {child_menu.child.title}
                                              </Link>
                                            </li>
                                          );
                                        })}
                                    </ul>
                                  </li>
                                );
                              }
                            })}
                          </ul>
                          <div
                            onClick={() => {
                              setMenuOpenBooking(!menuOpenBooking);
                            }}
                            onKeyDown={() => {
                              setMenuOpenBooking(!menuOpenBooking);
                            }}
                            aria-hidden="true"
                            className={`${
                              menuOpenBooking ? "active" : ""
                            } hidden smscreen2:block smscreen2:mt-20 `}
                          >
                            <div className="btn-custom">
                              <Link to="/" className="btn btn-lightblue">
                                make a booking
                              </Link>
                            </div>
                          </div>
                        </div>
                        <div className="mainNav__submenu leftMenu flex flex-wrap justify-end gap-x-14 border-t-1 border-lightblue pt-50 mt-50 mdscreen:pt-25 mdscreen:mt-25">
                          <ul className="flex flex-wrap gap-x-5 text-right justify-end items-end w-[50%] desktop2:w-[70%] smscreen2:w-[90%] xsscreen:grid-cols-1">
                            {headersideBottomMenu.map((menu, i) => {
                              return (
                                <li key={i}>
                                  <Link
                                    to={menu.item.url}
                                    target={menu.item.target}
                                  >
                                    {menu.item.title}
                                  </Link>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                        <div className="ct-info flex flex-col pt-30 leftMenu gap-y-1">
                          <span>
                            {headerDataList?.sidebarMenuEmail && (
                              <Link
                                to={`mailto:${headerDataList.sidebarMenuEmail}`}
                                className="text-white relative text-16 tracking-08em font-300 transition-all duration-300"
                              >
                                {headerDataList.sidebarMenuEmail}
                              </Link>
                            )}
                          </span>
                          <span>
                            {headerDataList?.sidebarMenuPhone && (
                              <Link
                                to={`tel:${headerDataList.sidebarMenuPhone}`}
                                className="text-white relative text-16 tracking-08em font-300 transition-all duration-300"
                              >
                                {headerDataList.sidebarMenuPhone}
                              </Link>
                            )}
                          </span>
                        </div>
                        <div className="sicon flex pt-25 gap-x-3 leftMenu justify-end pb-60 mdscreen:pb-100">
                          {headerDataList?.sidebarMenuSocial.map(
                            (social, i) => (
                              <li key={i}>
                                <Link
                                  to={social.link.url}
                                  target={social.link.target}
                                  className="w-25 h-25 bg-white flex items-center justify-center rounded-500 hover:bg-lightblue transition-all duration-300"
                                >
                                  <img
                                    src={social.icon.mediaItemUrl}
                                    alt={social.icon.altText}
                                    width={12}
                                    height={14}
                                    loading="eager"
                                  />
                                </Link>
                              </li>
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:w-4/12 w-full lgscreen:hidden">
              <ImageOpt
                imgData={headerDataList.thankyouImage.mediaItemUrl}
                imgAlt={headerDataList.thankyouImage.altText}
                width={1440}
                height={640}
                imgLoad="eager"
                imgClass="h-screen w-full object-cover"
              />
            </div>
          </div>
        </section>
      </>
    </div>
  );
};

export default Thankyou;
export const Head = () => <title>Thank You | Labotessa</title>;
